var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('window-header'),_c('nav-form',{scopedSlots:_vm._u([{key:"after",fn:function(){return [(_vm.mode == 'new' || _vm.mode == 'edit')?_c('button',{staticClass:"button button-fill",on:{"click":_vm.importLines}},[_c('fa-icon',{attrs:{"icon":"file-import"}}),_c('span',[_vm._v("Importar líneas")])],1):_vm._e()]},proxy:true},{key:"actions",fn:function(){return [(_vm.itemId)?_c('li',{on:{"click":function($event){return _vm.exportarLineasCSV('albaran_id')}}},[_vm._v(" Exportar líneas ")]):_vm._e()]},proxy:true},{key:"reports",fn:function(){return [_vm._l(((_vm.app.config.plantillas_documento_albaran_proveedor || [])),function(p){return _c('li',{key:'pdpc-' + p.codigo,class:{ disabled: !_vm.itemId },on:{"click":function($event){return _vm.openURL(_vm.app.urlGeneradorInformesDocumentoPrint, { id: p.codigo, conditions: [['id', '=', _vm.itemId]] })}}},[_vm._v(" Documento: "+_vm._s(p.nombre)+" ")])}),_vm._l(((_vm.app.config.plantillas_etiqueta_albaran_proveedor || [])),function(p){return _c('li',{key:'pdpc-' + p.codigo,class:{ disabled: !_vm.itemId },on:{"click":function($event){return _vm.openURL(_vm.app.urlGeneradorInformesEtiquetaPrint, { id: p.codigo, conditions: [['id', '=', _vm.itemId]] })}}},[_vm._v(" Etiquetas: "+_vm._s(p.nombre)+" ")])})]},proxy:true}])}),_c('section',[_c('article',{staticStyle:{"height":"395px"}},[_c('field',{staticStyle:{"top":"5px","left":"5px"},attrs:{"name":"ndoc","widget":"char","searchable":"","label":"Nº Albarán","width":"110px","inputStyle":"text-align:right;"}}),_c('field',{staticStyle:{"top":"5px","left":"130px"},attrs:{"name":"fecha","type":"date","label":"Fecha","width":"100px"}}),_c('field',{ref:"proveedor_id",staticStyle:{"top":"5px","right":"55px"},attrs:{"autofocus":"","name":"proveedor_id","widget":"m2o","label":"Proveedor","searchable":"","width":"320px","labelProp":"nombre_comercial","imgProp":"imagen.imagen","filter":['activo', '=', 1],"fields":[
          'nacionalidad',
          { name: 'divisa_id', fields: ['codigo', 'nombre', 'ratio'] },
          { name: 'impuesto_id', fields: ['nombre', 'valor'] },
          'descuento_especial',
          'financiacion',
          { name: 'comentarios', fields: ['descripcion', 'fecha', 'activo'] },
          {
            name: 'forma_pago_id',
            fields: [
              'codigo',
              'descripcion',
              'vencimientos',
              'periodicidad',
              'periodicidad_unidades' ],
          },
          'descuento_linea_unidad',
          'descuento_linea_peso',
          'merma',
          'merma_linea'
        ]}}),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Mostrar comentarios'),expression:"'Mostrar comentarios'"}],staticClass:"button button-plain",class:{ disabled: !_vm.formData.proveedor_id },staticStyle:{"position":"absolute","top":"15px","right":"22px"},attrs:{"href":"#"},on:{"click":_vm.mostrarComentariosProveedor}},[_c('fa-icon',{attrs:{"icon":"sticky-note"}})],1),_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Abrir saldos'),expression:"'Abrir saldos'"}],staticClass:"button button-plain",class:{ disabled: !_vm.formData.proveedor_id },staticStyle:{"position":"absolute","top":"15px","right":"5px"},attrs:{"href":"#"},on:{"click":_vm.abrirSaldos}},[_c('fa-icon',{attrs:{"icon":"dollar-sign"}})],1),_c('r-tabs',{ref:"main-tabs",staticStyle:{"top":"40px","height":"353px"},attrs:{"wt":_vm.formData.wt,"buttons":[
        'Cabecera',
        'Otros costes',
        'Líneas',
        'Pie',
        'Taquería',
        'Estadísticas' ],"classButton":{
        disabled: !_vm.formData.proveedor_id && _vm.mode != 'search',
      }},on:{"active":_vm.onActiveTab}},[_c('div',{staticClass:"tab"},[_c('field',{staticStyle:{"top":"10px","left":"10px"},attrs:{"name":"nalbaran","widget":"char","label":"S. Nº de Albarán","width":"150px"}}),_c('field',{staticStyle:{"top":"10px","left":"178px"},attrs:{"name":"falbaran","type":"date","label":"F. Albarán","width":"100px"}}),_c('field',{staticStyle:{"top":"10px","right":"10px"},attrs:{"name":"condicional","widget":"toggle","label":"Condicional","labels":{ checked: 'Sí', unchecked: 'No' },"width":45,"inline-label":""}}),_c('fieldset',{staticStyle:{"position":"relative","left":"10px","top":"50px","width":"230px","height":"59px"}},[_c('legend',[_vm._v("Importación")]),_c('field',{staticStyle:{"top":"6px","left":"20px"},attrs:{"name":"importacion","widget":"radio","readonly":true,"default":"union_europea","options":{
              Nacional: 'nacional',
              'Extracom.': 'extracomunitario',
              UE: 'union_europea',
            },"inline-label":""}})],1),_c('field',{ref:"divisa_id",staticStyle:{"top":"115px","left":"10px"},attrs:{"name":"divisa_id","widget":"m2o","label":"Divisa","width":"120px","fields":['ratio'],"external-window":"moneda"}}),_c('field',{class:{ wrong: _vm.formData.divisa_id && !parseFloat(_vm.formData.cambio) },staticStyle:{"top":"115px","left":"160px"},attrs:{"name":"cambio","widget":"float","type":"number","dec":"6","label":"Cambio","width":"80px"}}),_c('fieldset',{staticStyle:{"position":"relative","left":"250px","top":"-9px","width":"380px","height":"59px"}},[_c('legend',[_vm._v("Metal")]),_c('field',{ref:"tipo_metal",staticStyle:{"top":"6px","left":"15px"},attrs:{"name":"tipo_metal","widget":"radio","default":"no","options":{ No: 'no', Cuenta: 'cuenta', Factura: 'factura' }}}),_c('field',{ref:"metal_id",staticStyle:{"top":"7px","left":"192px"},attrs:{"name":"metal_id","widget":"m2o","labelProp":"descripcion","readonly":_vm.formData.tipo_metal != 'cuenta' &&
              _vm.formData.tipo_metal != 'factura',"width":"170px","fields":['cotizacion', 'factor']}})],1),_c('field',{staticStyle:{"top":"115px","left":"275px"},attrs:{"name":"prmetalp","widget":"float","type":"number","dec":"2","inputStyle":"text-align:center;","label":"Pr. Metal/P","width":"70px","readonly":_vm.formData.tipo_metal != 'cuenta' &&
              _vm.formData.tipo_metal != 'factura'}}),_c('field',{staticStyle:{"top":"153px","left":"275px"},attrs:{"name":"factor","widget":"float","inputStyle":"text-align:right;font-size:10px;","type":"number","dec":"4","inline-label":"","label":"Factor","width":"40px","readonly":true}}),_c('field',{staticStyle:{"top":"115px","left":"350px"},attrs:{"name":"merma","widget":"float","type":"number","dec":"2","inputStyle":"text-align:center;","label":"Merma (%/m)","width":"70px","readonly":_vm.formData.tipo_metal != 'cuenta' &&
              _vm.formData.tipo_metal != 'factura'}}),_c('field',{staticStyle:{"top":"115px","left":"425px"},attrs:{"name":"contraste","widget":"float","type":"number","dec":"2","inputStyle":"text-align:center;","label":"Contraste/P","width":"70px"}}),_c('field',{staticStyle:{"top":"115px","left":"500px"},attrs:{"name":"ocostes","widget":"float","type":"number","dec":"2","inputStyle":"text-align:center;","label":"O. Costes/P","width":"70px"}}),_c('field',{staticStyle:{"top":"153px","left":"526px"},attrs:{"name":"mermaporlinea","widget":"checkbox","inline-label":"","label":"Merma por Línea"}}),_c('field',{staticStyle:{"top":"168px","left":"11px"},attrs:{"name":"adjuntos","max":6,"widget":"files","label":"Adjuntos"}}),_c('field',{staticStyle:{"top":"168px","right":"11px"},attrs:{"name":"observaciones","widget":"text","label":"Observaciones","width":"429px","height":"40px"}}),_c('field',{staticStyle:{"top":"243px","left":"10px"},attrs:{"name":"delegacion_id","widget":"m2o","label":"Deleg.","width":"277px","readonly":_vm.mode == 'edit',"inputStyle":"font-weight:bold;text-align:center;","searchable":""}}),_c('field',{staticStyle:{"top":"243px","left":"295px"},attrs:{"name":"tipo_id","widget":"m2o","label":"Tipo","width":"290px","readonly":_vm.mode == 'edit',"searchable":""}})],1),_c('div',{staticClass:"tab"},[_c('field',{ref:"otroscostes",staticStyle:{"top":"5px","left":"4px","width":"648px"},attrs:{"name":"otroscostes","widget":"handsontable","height":225,"minRows":9,"columns":[
              {
                name: 'c',
                header: 'Coste',
                type: 'm2o',
                label: 'descripcion',
                primary: 'codigo',
                showCode: true,
                fields: ['descripcion', 'precio_predeterminado'],
              },
              {
                name: 'impdivisa',
                header: 'Imp. Divisa',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                help: 'Importe en la divisa del albarán',
              },
              {
                name: 'impdivisabase',
                header: 'Imp. Div. Base',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                help: 'Importe en la divisa base',
              },
              {
                name: 'p',
                header: 'P',
                type: 'checkbox',
                help: 'Incluir el importe en el pie del albarán',
              },
              {
                name: 'l',
                header: 'L',
                type: 'checkbox',
                help: 'Repercutir el importe en el coste de los artículos',
              } ]}}),_c('fieldset',{staticStyle:{"position":"absolute","left":"10px","bottom":"10px","width":"270px","height":"59px"}},[_c('legend',[_vm._v("Recalcular")]),_c('field',{staticStyle:{"top":"5px","left":"30px"},attrs:{"name":"recalcular","widget":"radio","default":"union_europea","options":{
              'Margen de venta': 'margen_venta',
              'Precio de venta': 'precio_venta',
            },"inline-label":""}})],1)],1),_c('div',{staticClass:"tab"},[_c('field',{ref:"lineas",staticClass:"lineas",staticStyle:{"top":"5px","left":"4px","width":"648px"},attrs:{"name":"lineas","htSettings":{
            rowHeights: 15,
            cells: _vm.cellsLineas,
          },"widget":"handsontable","height":303,"minRows":18,"customprop":"lineas_customprop","fields":[{ name: 'origin_pedido_id', fields: ['ndoc'] }],"columns":[
              {
                name: 'ean13',
                header: '|||||||||',
                help: 'Código de barras del artículo',
              },
              {
                name: 'modelo_id',
                header: 'Modelo',
                help: 'Modelo del artículo',
                type: 'm2o',
                primary: 'codigo',
                label: 'codigo',
              },
              {
                name: 'articulo_id',
                header: 'Artículo',
                help: 'Código del artículo',
                type: 'm2o',
                primary: 'codigo',
                label: 'codigo',
                noOpen: true,
                fields: [
                  { name: 'thumbnail', fields: ['imagen'] },
                  { name: 'familia_id', fields: ['codigo', 'nombre'] } ],
              },
              {
                name: 'descripcion',
                help: 'Descripción del artículo',
                header: 'Descripción',
              },
              {
                name: 'refproveedor',
                header: 'R. Proveedor',
                help: 'Ref. del proveedor del artículo',
              },
              //{name:'familia_id',header:'Familia', type:'m2o', primary:'codigo', label:'codigo', readOnly:true},
              { name: 'nota', header: 'Nota' },
              //{name:'tt',header:'T', type:'select', options:['A','R']},
              {
                name: 'almacen_id',
                header: 'Almacén',
                help: 'Almacén',
                type: 'm2o',
                primary: 'codigo',
                label: 'codigo',
                readOnly: true,
              },
              {
                name: 'unidades',
                header: 'Unid.',
                help: 'Unidades',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'etiqueta',
                help: 'Etiquetas',
                header: 'Etiq.',
                type: 'numeric',
              },
              {
                name: 'peso',
                header: 'Peso',
                help: 'Peso',
                type: 'numeric',
                numericFormat: { pattern: '0,0.000' },
              },
              {
                name: 'c',
                header: 'C',
                help: '<U> Compra por Unidad <P> Compra por Peso',
                type: 'select',
                options: ['U', 'P'],
              },
              {
                name: 'm',
                header: 'M',
                help: 'Compra con Metal incluido',
                type: 'checkbox',
              },
              {
                name: 'r',
                header: 'R',
                help: 'Compra con Rec. equivalencia',
                type: 'checkbox',
              },

              {
                name: 'precio',
                header: 'Precio',
                help: 'Precio Compra',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'descuentos',
                header: 'Dtos.',
                help: 'Dto.',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                //sufix: '%',
              },
              {
                name: 'totallinea',
                header: 'Total Línea',
                help: 'Total Línea',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'm2',
                header: 'M',
                help: 'Marcar si se acumula el peso del metal',
                type: 'checkbox',
              },
              {
                name: 'c2',
                header: 'C',
                help: 'Marcar si se aplica Contraste por peso',
                type: 'checkbox',
              },
              {
                name: 'o',
                header: 'O',
                help: 'Marcar si se aplica Otros Costes por Peso',
                type: 'checkbox',
              },
              {
                name: 'precio_coste',
                header: 'P. Coste',
                help: 'Precio de coste del artículo',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'coste_fijo',
                header: 'Coste Fijo',
                help: 'Coste fijo por Unidad que se incrementará al coste de la pieza',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'taqueria_ids',
                header: 'Taquería',
                help: 'Cód. Taqueria',
                type: 'm2m',
                primary: 'codigo',
                image: 'thumbnail.imagen',
                label: 'codigo',
                fields: ['precio_coste'],
                filter: function () { return ['seccion_id', '=', 'PCK']; },
              },
              {
                name: 'taqueria_precio',
                header: 'Taq.(€)',
                help: 'Coste total de taqueria',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'incluir_taqueria',
                header: 'P',
                help: 'Marcar si se incrementará al coste de la pieza el precio de la taquería',
                type: 'checkbox',
              },
              {
                name: 'otros_costes',
                header: 'O. Costes',
                help: 'Otros Costes repercutidos por línea. Se incrementará al coste de la pieza',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'v',
                header: 'V',
                help: '<U> Venta por Unidad <P> Venta por Peso',
                type: 'select',
                options: ['U', 'P'],
              },

              {
                name: 'm3',
                header: 'M',
                help: 'Venta con metal incluido',
                type: 'checkbox',
              },
              {
                name: 'margen',
                header: '%',
                help: '% de Margen comercial',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
                //sufix: '%',
              },
              {
                name: 'pventa',
                header: 'P.Venta',
                help: 'Precio de Vta. al cliente',
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 't',
                header: 'T',
                help: 'Tarifa en la que se grabará el P.Venta',
                type: 'numeric',
                numericFormat: { pattern: '0,0' },
              },
              {
                name: 'unidades_pendientes',
                header: 'Uds.Pend.',
                help: 'Unidades pendientes de facturar',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'peso_pendiente',
                header: 'Peso.Pend.',
                help: 'Peso pendiente de facturar',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'unidades_devueltas',
                header: 'Uds.Dev.',
                help: 'Unidades devueltas',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              },
              {
                name: 'peso_devuelto',
                header: 'Peso.Dev.',
                help: 'Peso devuelto',
                readOnly: true,
                type: 'numeric',
                numericFormat: { pattern: '0,0.00' },
              } ]}})],1),_c('div',{staticClass:"tab"},[_c('field',{staticStyle:{"top":"5px","right":"328px"},attrs:{"name":"total_unidades","widget":"float","type":"number","dec":"2","label":"Total Unidades","width":"70px","readonly":true}}),_c('field',{staticStyle:{"top":"5px","right":"250px"},attrs:{"name":"total_peso","widget":"float","type":"number","dec":"3","label":"Total Peso","width":"70px","readonly":true,"suffix":" g"}}),_c('field',{staticStyle:{"top":"10px","right":"12px"},attrs:{"name":"total_articulos","widget":"float","type":"number","dec":"2","label":"Total Artículos","inline-label":"","width":"70px","readonly":true}}),_c('field',{staticStyle:{"top":"30px","right":"90px"},attrs:{"name":"dto_especial_porcentaje","widget":"float","type":"number","dec":"2","label":"Dto. Especial","inline-label":"","width":"70px","placeholder":"%","suffix":" %"}}),_c('field',{staticStyle:{"top":"30px","right":"12px"},attrs:{"name":"dto_especial","widget":"float","type":"number","dec":"2","width":"70px"}}),_c('field',{staticStyle:{"top":"45px","right":"328px"},attrs:{"name":"g18k","widget":"float","type":"number","dec":"3","label":(_vm.formData.metal_id && _vm.formData.metal_id.descripcion) ||
            'G. Aleación',"width":"70px","suffix":" g"}}),_c('field',{staticStyle:{"top":"45px","right":"250px"},attrs:{"name":"gmerma","widget":"float","type":"number","dec":"3","label":"G. Merma","width":"70px","suffix":" g"}}),_c('field',{staticStyle:{"top":"50px","right":"90px"},attrs:{"name":"g24k_porcentaje","widget":"float","type":"number","dec":"3","label":(_vm.formData.metal_id && _vm.formData.metal_id.descripcion) ||
            'G. Aleación',"inline-label":"","width":"70px","readonly":true,"suffix":" g"}}),_c('field',{staticStyle:{"top":"50px","right":"12px"},attrs:{"name":"g24k","widget":"float","type":"number","dec":"2","width":"70px","readonly":true}}),_c('field',{staticStyle:{"top":"70px","right":"90px"},attrs:{"name":"gcontraste_porcentaje","type":"number","dec":"3","widget":"float","label":"G. Contraste","inline-label":"","width":"70px","suffix":" g"}}),_c('field',{staticStyle:{"top":"70px","right":"12px"},attrs:{"name":"gcontraste","widget":"float","type":"number","dec":"2","width":"70px","readonly":true}}),_c('field',{staticStyle:{"top":"90px","right":"90px"},attrs:{"name":"gotroscostes_porcentaje","widget":"float","type":"number","dec":"3","label":"G. Otros Costes","inline-label":"","width":"70px","suffix":" g"}}),_c('field',{staticStyle:{"top":"90px","right":"12px"},attrs:{"name":"gotroscostes","widget":"float","type":"number","dec":"2","width":"70px","readonly":true}}),_c('field',{staticStyle:{"top":"110px","right":"12px"},attrs:{"name":"costes_adicionales","widget":"float","label":"Costes adicionales","inline-label":"","width":"70px","type":"number","dec":"2","readonly":""}}),_c('field',{staticStyle:{"top":"130px","right":"90px"},attrs:{"name":"financiacion_porcentaje","widget":"float","type":"number","dec":"2","label":"Financiación","inline-label":"","width":"70px","placeholder":"%","suffix":" %"}}),_c('field',{staticStyle:{"top":"130px","right":"12px"},attrs:{"name":"financiacion","widget":"float","type":"number","dec":"2","inline-label":"","width":"70px"}}),_c('field',{staticStyle:{"top":"10px","left":"14px"},attrs:{"name":"comprobante_factura_emitido","widget":"checkbox","label":"Comprobante de Factura Emitido","reverse":"","inline-label":""}}),_c('field',{staticStyle:{"top":"30px","left":"14px"},attrs:{"name":"etiquetas_facturas_emitidas","widget":"checkbox","label":"Etiquetas de Facturas Emitidas","reverse":"","inline-label":""}}),_c('div',{staticStyle:{"position":"absolute","bottom":"0px"}},[_c('table',{staticClass:"tabla-pie"},[_c('tr',[_c('td'),_c('th',[_vm._v("B. Imponible")]),_c('th',[_vm._v(" "+_vm._s(_vm.formData.tipo_impuesto)+" ("+_vm._s(_vm.formData.ivap)+"%) ")]),_c('th',[_vm._v(" Recargo ("+_vm._s(_vm.$utils.misc.formatNumber(_vm.formData.rep))+"%) ")]),_c('th',[_c('b',[_vm._v("Totales")])])]),_c('tr',[_c('td',{staticStyle:{"width":"100px"}},[_vm._v("Base 1 "),_c('small',[_vm._v("(IMP.)")])]),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"baseimponible_sre","widget":"float","type":"number","width":"100%","readonly":true}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"iva_sre","widget":"float","type":"number","width":"100%","readonly":true}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"recargo_equivalencia_sre","widget":"float","type":"number","width":"100%","readonly":true}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"total2","widget":"float","type":"number","width":"100%","readonly":true}})],1)]),_c('tr',[_c('td',{staticStyle:{"width":"115px"}},[_vm._v("Base 2 "),_c('small',[_vm._v("(IMP.+RE)")])]),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"baseimponible_re","widget":"float","type":"number","width":"100%","readonly":true}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"iva_re","widget":"float","type":"number","width":"100%","readonly":true}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"recargo_equivalencia_re","widget":"float","type":"number","width":"100%","readonly":true}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"total1","widget":"float","type":"number","width":"100%","readonly":true}})],1)]),_c('tr',[_c('td',[_vm._v(" Base Metal "),_c('field',{staticStyle:{"display":"inline-flex"},attrs:{"name":"base_metal_check","widget":"checkbox"}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"baseimponible_metal","widget":"float","type":"number","width":"100%","readonly":true}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"iva_metal","widget":"float","type":"number","width":"100%","readonly":true}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"recargo_equivalencia_metal","widget":"float","type":"number","width":"100%","readonly":true}})],1),_c('td',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"total_metal","widget":"float","type":"number","width":"100%","readonly":true}})],1)]),_c('tr',[_c('th',{staticClass:"total-cell",attrs:{"colspan":"4"}},[_vm._v("Rec. Financiero")]),_c('th',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"financiacion","widget":"float","type":"number","width":"100%","readonly":true}})],1)]),_c('tr',[_c('th',{staticClass:"total-cell",attrs:{"colspan":"4"}},[_vm._v("Total")]),_c('th',[_c('field',{staticStyle:{"position":"relative"},attrs:{"name":"total","widget":"float","type":"number","width":"100%","readonly":true,"inputStyle":"font-weight:bold; background: rgba(0, 140, 186, 0.3)!important;"}})],1)])])])],1),_c('div',{staticClass:"tab"},[_c('field',{ref:"taqueria_lineas",staticStyle:{"top":"10px","left":"10px","width":"637px"},attrs:{"name":"taqueria_lineas","widget":"handsontable","height":278,"minRows":12,"readonly":true,"customprop":"taquerialineas_customprop","columns":[
              {
                name: 'taqueria_id',
                header: 'Artículo',
                type: 'm2o',
                model: 'articulo',
                primary: 'codigo',
                showCode: true,
                image: 'thumbnail.imagen',
                label: 'nombre',
                filter: function (value, row, prop) { return ['seccion_id', '=', 'PCK']; }
              },
              {
                name: 'unidades_teoricas',
                header: 'Unidades',
                type: 'numeric',
                format: '0',
                readOnly: true,
              } ]}})],1),_c('div',{staticClass:"tab"},[_c('field',{staticStyle:{"top":"10px","left":"14px"},attrs:{"name":"total_unidades","widget":"float","type":"number","dec":"2","label":"Total Unidades","inline-label":"","width":"80px","readonly":true}}),_c('field',{staticStyle:{"top":"10px","left":"195px"},attrs:{"name":"total_peso","widget":"float","type":"number","dec":"3","label":"Total Peso","inline-label":"","width":"80px","readonly":true}}),_c('field',{staticStyle:{"top":"10px","left":"350px"},attrs:{"name":"total","widget":"float","type":"number","dec":"2","label":"Total Importe","inline-label":"","width":"80px","readonly":true}}),_c('div',{staticClass:"item-input inline-label field",staticStyle:{"top":"10px","left":"520px"}},[_c('div',{staticClass:"item-inner"},[_c('label',{staticClass:"item-title item-label"},[_vm._v("€/pieza")]),_c('div',{staticClass:"item-input-wrap"},[_c('input',{staticStyle:{"width":"80px","text-align":"right"},attrs:{"name":"precio_medio_pieza","type":"text","readonly":""},domProps:{"value":_vm.precioMedioPieza}})])])]),_c('field',{ref:"estadisticas_familias",staticStyle:{"top":"45px","left":"10px","width":"637px"},attrs:{"name":"estadisticas_familias","widget":"handsontable","height":247,"minRows":10,"readonly":true,"columns":[
              {
                name: 'familia_id',
                header: 'Familia',
                type: 'm2o',
                label: 'nombre',
                primary: 'codigo',
                showCode: true,
                model: 'familia',
              },
              {
                name: 'unidades',
                header: 'Unidades',
                type: 'numeric',
                format: '0',
              },
              {
                name: 'precio_medio',
                header: 'Precio medio',
                type: 'numeric',
                format: '0,0.00',
              } ]}})],1)])],1)]),_c('v-collapse-wrapper',{ref:"main-collapse",attrs:{"active":true}},[_c('div',{directives:[{name:"collapse-toggle",rawName:"v-collapse-toggle"}],staticClass:"header"},[_vm._v(" Listado "),_c('div',{staticClass:"item-after"},[(_vm.years.length)?_c('field',{staticStyle:{"position":"relative","width":"100px","margin-right":"24px"},attrs:{"widget":"select","name":"anio","width":"100","options":_vm.years.reduce(function (a, v) {
                  var _obj;

                  return (Object.assign({}, a, ( _obj = {}, _obj[v] = v, _obj )));
}, {}),"searchable":"","readonly":_vm.mode != 'search',"placeholder":"Todos los años"},on:{"click":function($event){return $event.stopPropagation()}}}):_vm._e(),_vm._v(" "+_vm._s(_vm.count)+" ")],1)]),_c('div',{directives:[{name:"collapse-content",rawName:"v-collapse-content"}],staticClass:"my-content"},[_c('hot-table',{ref:"hotTableComponent",attrs:{"settings":_vm.htSettings}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }